module.exports = __webpack_public_path__ + "media/images/icon__point--white@2x-1598f3e97c0e96bb7bec61819c6bd904.png";